import React, { useEffect, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import classNames from "classnames";
import styled from "styled-components/macro";

const EditableTitleRoot = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: -6px;

  .title,
  textarea {
    font-family: "GT Super Text";
    font-weight: 400;
    font-size: 19px;
    line-height: 1.2em;
    color: var(--grey-0);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 3px 6px;
    width: 100%;
    max-height: 100px;
  }

  .title {
    border: 1px solid transparent;
    cursor: text;
    overflow: hidden;
  }

  .title.readonly {
    cursor: inherit;
  }

  .title:not(.readonly):hover {
    border: 1px solid var(--grey-2);
  }

  .title-text {
    line-clamp: 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }

  textarea {
    display: block;
    resize: none;
    border: 1px solid var(--primary-cta);
    background-color: transparent;
  }
`;

export default function EditableTitle({ title, onRename, disabled, className, children }) {
  const [value, setValue] = useState(title);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setValue(title);
    }
  }, [title, isEditing]);

  const commit = () => {
    setIsEditing(false);
    const next = value.trim();
    if (next && next !== title) {
      onRename(next);
    } else {
      setValue(title);
    }
  };

  return (
    <EditableTitleRoot className={className}>
      {isEditing ? (
        <TextareaAutosize
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onBlur={commit}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.target.blur();
            }
          }}
          onClick={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
          autoFocus
          rows={3}
          spellCheck={false}
        />
      ) : (
        <div
          className={classNames("title", { readonly: disabled })}
          title={title}
          onClick={(event) => {
            if (disabled) {
              return;
            }
            event.stopPropagation();
            setIsEditing(true);
          }}
        >
          <div className="title-text">{children ?? title}</div>
        </div>
      )}
    </EditableTitleRoot>
  );
}
